import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class DiscoveryHubDto extends InspectionCase {
  item_6_1?: InspectionValueCase;
  item_6_2?: InspectionValueCase;
  item_6_3?: InspectionCase;
  item_6_4?: InspectionCase;
  item_6_5?: InspectionCase;
  item_6_6?: InspectionCase;
  item_6_7?: InspectionCase;
  item_6_8?: InspectionCase;
  item_6_9?: InspectionCase;
  item_6_10?: InspectionCase;
  item_6_11?: InspectionCase;
  item_6_12?: InspectionCase;
  item_6_13?: InspectionCase;
  item_6_14?: InspectionCase;
  item_6_15?: InspectionCase;
}

export class DiscoveryHub extends DiscoveryHubDto {
  constructor(data: DiscoveryHubDto = { title: 'רכזת הגילוי' }) {
    super(data);
    this.item_6_1 = new InspectionValueCase({
      ...data.item_6_1,
      title: `מיקום התקנת הרכזת`
    });
    this.item_6_2 = new InspectionValueCase({
      ...data.item_6_2,
      title: `לוח המשנה הותקן ליד`
    });
    this.item_6_3 = new InspectionCase({
      ...data.item_6_3,
      title: `האתר מאויש 24 שעות ביממה. הרכזת או לוח המשנה ממוקמים במקום זה`
    });
    this.item_6_4 = new InspectionCase({
      ...data.item_6_4,
      title: `יש חיווי תקלת מצברים ברכזת`
    });
    this.item_6_5 = new InspectionCase({
      ...data.item_6_5,
      title: `חיווי תקלת מתח רשת`
    });
    this.item_6_6 = new InspectionCase({
      ...data.item_6_6,
      title: `מדידת הזרם תבוצע ברזולוציה הגבוהה של המכשיר (400 מילי אמפר)`
    });
    this.item_6_7 = new InspectionCase({
      ...data.item_6_7,
      title: `גובה יחידת הבקרה מהרצפה לא יעלה על 2 מ' מחלקה העליון של הרכזת`
    });
    this.item_6_8 = new InspectionCase({
      ...data.item_6_8,
      title: `הרכזת המשנית מדווחת דיווחי תקלה / אזעקה לרכזת הראשית`
    });
    this.item_6_9 = new InspectionCase({
      ...data.item_6_9,
      title: `יחידת הבקרה מחוברת למפסק חצי אוטומטי נפרד מוזנת מלוח`
    });
    this.item_6_10 = new InspectionCase({
      ...data.item_6_10,
      title: `מפסק דו קוטבי עם אמצעי נעילה מעגל`
    });
    this.item_6_11 = new InspectionCase({
      ...data.item_6_11,
      title: `כל כבלי הגילוי אש מוגנים ע"י מוביל / צינור תיקני`
    });
    this.item_6_12 = new InspectionCase({
      ...data.item_6_12,
      title: `כבלי הפיקוד בין הרכזת למערכות מצילות חיים מוגנות במשך 120 דקות בהתאם לתקן הגרמני DIN4102Q/12`
    });
    this.item_6_13 = new InspectionCase({
      ...data.item_6_13,
      title: `מעטה הבידוד יהיה בצבע אדום לכל אורכו כולל מובילים כפופים וגמישים`
    });
    this.item_6_14 = new InspectionCase({
      ...data.item_6_14,
      title: `צנרת התיעול מחוזקת בצורה יציבה עם תוופסנים הממוקמים במרחק של לא יותר מ-0.6 מ' האחד מהשני, החיבורים נעשו באמצעות הלחמה, עטופים בשרוולים או מהדקים תיקניים`
    });
    this.item_6_15 = new InspectionCase({
      ...data.item_6_15,
      title: `בחדרי מדרגות ופירים מותקנים גלאים בראש המדרגות/פיר וכל 4 קומות`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_6_1.isApplicable || this.item_6_1.isPassed) &&
        (!this.item_6_2.isApplicable || this.item_6_2.isPassed) &&
        (!this.item_6_3.isApplicable || this.item_6_3.isPassed) &&
        (!this.item_6_4.isApplicable || this.item_6_4.isPassed) &&
        (!this.item_6_5.isApplicable || this.item_6_5.isPassed) &&
        (!this.item_6_6.isApplicable || this.item_6_6.isPassed) &&
        (!this.item_6_7.isApplicable || this.item_6_7.isPassed) &&
        (!this.item_6_8.isApplicable || this.item_6_8.isPassed) &&
        (!this.item_6_9.isApplicable || this.item_6_9.isPassed) &&
        (!this.item_6_10.isApplicable || this.item_6_10.isPassed) &&
        (!this.item_6_11.isApplicable || this.item_6_11.isPassed) &&
        (!this.item_6_12.isApplicable || this.item_6_12.isPassed) &&
        (!this.item_6_13.isApplicable || this.item_6_13.isPassed) &&
        (!this.item_6_14.isApplicable || this.item_6_14.isPassed) &&
        (!this.item_6_15.isApplicable || this.item_6_15.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_6_1.getNotes(),
      ...this.item_6_2.getNotes(),
      ...this.item_6_3.getNotes(),
      ...this.item_6_4.getNotes(),
      ...this.item_6_5.getNotes(),
      ...this.item_6_6.getNotes(),
      ...this.item_6_7.getNotes(),
      ...this.item_6_8.getNotes(),
      ...this.item_6_9.getNotes(),
      ...this.item_6_10.getNotes(),
      ...this.item_6_11.getNotes(),
      ...this.item_6_12.getNotes(),
      ...this.item_6_13.getNotes(),
      ...this.item_6_14.getNotes(),
      ...this.item_6_15.getNotes()
    ];
  }
}
